import AddressInfo from "components/AddressInfo";

export default AddressInfo;
